// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2EM9b","header":"PatientQuestionnaire_header__3yLgS","info":"PatientQuestionnaire_info__djrlJ"};